import { render } from "./DocumentItem.vue?vue&type=template&id=5703e014&scoped=true"
import script from "./DocumentItem.vue?vue&type=script&lang=js"
export * from "./DocumentItem.vue?vue&type=script&lang=js"

import "./DocumentItem.vue?vue&type=style&index=0&id=5703e014&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5703e014"]])

export default __exports__